import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(relativeTime);
dayjs.extend(updateLocale);

dayjs.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years',
  },
});

export const formatChatTime = (timestamp) => {
  const now = dayjs();
  const date = dayjs(timestamp);

  if (date.isSame(now, 'day')) {
    return date.format('HH:mm'); // Today -> "5:42 AM"
  } else if (date.isSame(now.subtract(1, 'day'), 'day')) {
    return 'Yesterday'; // Yesterday
  } else if (date.isAfter(now.subtract(7, 'days'))) {
    return date.format('dddd'); // Last 7 days -> "Monday"
  } else if (date.isSame(now, 'year')) {
    return date.format('DD/MM/YYYY'); // This year -> "02/03/2024"
  } else {
    return date.format('DD/MM/YYYY'); // Older than a year -> "15/09/2023"
  }
};
